export var mapLegalEntityObject = function (_a) {
    var type = _a.type, data = _a.data;
    return ({
        type: type,
        data: {
            title: data.title,
            inn: data.inn,
            kpp: data.kpp,
            phone: data.phone,
            address: {
                legal: data.address.legal,
                physical: data.address.physical,
            },
            musicLicenseInvoices: data.musicLicenseInvoices,
        },
    });
};
